import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.jsx"
import "./App.css"
import "./index.css"

// Suppress harmless console warnings from third-party libraries
const originalWarn = console.warn
console.warn = (...args) => {
  if (args[0]?.includes?.('deprecated parameters') || args[0]?.includes?.('Navigated to')) {
    return
  }
  originalWarn.call(console, ...args)
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
